// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

class MagnifyGlass extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path d="M21.6,18.6l-4.9-5c0.6-1.1,1-2.4,1-3.8c0-4.3-3.5-7.9-7.8-7.9S2,5.4,2,9.8s3.5,7.9,7.8,7.9c1.4,0,2.7-0.3,3.8-1l4.9,5 c0.5,0.5,1.4,0.5,1.9,0l1.2-1.2C22.1,19.9,22.1,19.1,21.6,18.6z M5.1,9.8C5.1,7.2,7.2,5,9.8,5s4.7,2.1,4.7,4.8s-2.1,4.8-4.7,4.8 S5.1,12.4,5.1,9.8z" />
            </SvgIcon>
        );
    }
}

export default MagnifyGlass;
